<template>
  <div>
    <div v-loading="vloading" v-if="vloading" class="ifram"></div>
    <iframe v-else :src="url" frameborder="0" class="ifram"></iframe>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
        dcode: null,
        vloading: true,
        url: null,
        hisdoi: null,
    };
  },
  created () {
      this.dcode = this.$route.params.dcode
      this.read()
  },
  mounted(){
      document.getElementsByClassName("head-div")[0].style.display="none";
      document.getElementsByClassName("footer")[0].style.display="none";
  }, 
  methods: {
      read () {
        this.vloading = true
        axios({
            method:"get",
            url:`/api/operation/queryfulltext/?dcode=${encodeURIComponent(this.dcode)}&fta=${encodeURIComponent(this.$route.query.fta)}`,
            headers: {"Authentication": localStorage.getItem('login_info'), "Authentication-Fp": localStorage.getItem("fp"),
              'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
            responseType: 'blob',
          }).then((response)=>{
            let blob = new Blob([response.data], { type: response.data.type })
            this.url = URL.createObjectURL(blob)
            setTimeout(()=>{
              this.vloading = false
              this.hisdoi = sessionStorage.getItem(this.dcode)
              this.codecode = setInterval(()=>{
                if (this.hisdoi !== sessionStorage.getItem(this.dcode)) {
                  location.reload();
                }
              }, 1000);
            }, 100)
          }).catch(error=>{
            this.vloading = false
          })
      },
  }
};
</script>
<style scoped>
.ifram {
    width: 100%;
    height: calc(100vh - 3px);
}
</style>